function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.arama)
        params.set('arama', sorgu.arama);
    if (sorgu.durum)
        params.set('durum', sorgu.durum);
    if (sorgu.paraBirimi)
        params.set('paraBirimi', sorgu.paraBirimi);
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function noktalariListele(istemci, sorgu = {}) {
    return istemci.istek(`/noktalar${sorguDizgesi(sorgu)}`);
}
export async function noktaGetir(istemci, id) {
    return istemci.istek(`/noktalar/${id}`);
}
export async function noktaOlustur(istemci, giris) {
    return istemci.istek('/noktalar', { method: 'POST', body: JSON.stringify(giris) });
}
export async function noktaGuncelle(istemci, id, giris) {
    return istemci.istek(`/noktalar/${id}`, { method: 'PUT', body: JSON.stringify(giris) });
}
export async function noktaSil(istemci, id) {
    await istemci.istek(`/noktalar/${id}`, { method: 'DELETE' });
}
//# sourceMappingURL=noktalar.js.map